import { ElementType, PropsWithChildren } from "react"
import { useObjectRef } from "react-aria"
import { HeadingContext, useContextProps } from "react-aria-components"

import { cn } from "@/utilities/etc"

type HeadingLevel = 1 | 2 | 3 | 4 | 5 | 6

interface PageTitleProps extends React.HTMLAttributes<HTMLHeadingElement> {
  level?: HeadingLevel
  as?: HeadingLevel // To style it differently but still use the semantically correct heading tag
}

const Heading: React.FC<PropsWithChildren<PageTitleProps>> = (props) => {
  let ref = useObjectRef<HTMLHeadingElement>()
  ;[props, ref] = useContextProps(props, ref, HeadingContext)
  const level = props.level || 1
  const HeadingTag = `h${props.as || level}` as ElementType
  return (
    <HeadingTag
      {...props}
      className={cn(props.className, `headline--${level}`)}
    >
      {props.children}
    </HeadingTag>
  )
}

export default Heading
